import {
  CatalogKindExploreContent,
  ExploreLayout,
  ToolExplorerContent,
  GroupsExplorerContent,
} from '@backstage-community/plugin-explore';

export const ExplorePage = () => {
  return (
    <ExploreLayout
      title="company ecosystem"
      subtitle="Discover solutions available in your organisation"
    >


      <ExploreLayout.Route path="tools" title="Tools">
        <ToolExplorerContent />
      </ExploreLayout.Route>
      <ExploreLayout.Route path="groups" title="Groups">
        <GroupsExplorerContent />
      </ExploreLayout.Route>
      <ExploreLayout.Route path="systems" title="Systems">
        <CatalogKindExploreContent kind="system" />
      </ExploreLayout.Route>
{/*       <ExploreLayout.Route path="domains" title="Domains">
        <CatalogKindExploreContent kind="domain" />
      </ExploreLayout.Route> */}
    </ExploreLayout>
  );
};

export const explorePage = <ExplorePage />;
